import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, observable, runInAction } from "mobx";
import { localizePaymentInterval } from "../../../others/localizePaymentInterval.js";
import { formatNumber } from "../../../utils/getDecimalSeparator.js";
class Invoice {
    get labelTotal() {
        return formatNumber(+this.data.total);
    }
    get labelPaymentInterval() {
        return localizePaymentInterval(this.data.productPlan.paymentInterval);
    }
    // Net/gross treatment of the invoice total: "net" when Paddle reverse-charged the buyer, else "gross" (incl. VAT).
    get taxTreatment() {
        return this.data.isReverseCharge ? "net" : "gross";
    }
    constructor(data, store){
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], Invoice.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Invoice.prototype, "labelTotal", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], Invoice.prototype, "labelPaymentInterval", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", String),
    _ts_metadata("design:paramtypes", [])
], Invoice.prototype, "taxTreatment", null);
export { Invoice };
